import { render, staticRenderFns } from "./my-profile.vue?vue&type=template&id=58b44ea2&scoped=true&"
import script from "./my-profile.vue?vue&type=script&lang=js&"
export * from "./my-profile.vue?vue&type=script&lang=js&"
import style0 from "./my-profile.vue?vue&type=style&index=0&id=58b44ea2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58b44ea2",
  null
  
)

export default component.exports